import(/* webpackMode: "eager" */ "/app/app/blog/page.tsx");
